import styled from 'styled-components';

export const PaymentIncentiveContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	max-width: 320px;
	background-color: #fff;
	padding: 6.9rem 2rem;
`;
